import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import { Transition, useStyles } from './styles';

const VehiculoDetails = ({ details, onClose, openDetails }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={openDetails}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogContent style={{ display: 'flex', flexWrap: 'wrap' }}>
        {console.log(details)}

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Estado</Typography>
          <Typography className={classes.subTitles}>
            {details.estado === '1' ? 'Activo' : 'Inactivo'}
          </Typography>
        </div>

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Unidad de Negocio</Typography>
          <Typography className={classes.subTitles}>
            {details.nombre_unidad_negocio}
          </Typography>
        </div>
        
        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Marca</Typography>
          <Typography className={classes.subTitles}>
            {details.marca}
          </Typography>
        </div>

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Nombre Vehiculo</Typography>
          <Typography className={classes.subTitles}>
            {details.linea}
          </Typography>
        </div>
        
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="warning">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VehiculoDetails;
